import Api from '../../api/Api'

const promo = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    event: [],
    event_workshop_popular: [],
    detail_event: {},
    empty: '',
  },

  //mutations
  mutations: {
    SET_EVENT(state, event) {
      var temp = []
      event.forEach((el) => {
        let data = {
          label: el.judul,
          value: el.id_event,
        }
        temp.push(data)
      })

      state.event = temp
    },
    SET_EVENT_POPULAR_ADMIN(state, event) {
      const filter = event.filter((x) => x.id_jenis == 2)
      var temp = []
      event.forEach((el) => {
        let data = {
          label: el.judul,
          value: el.id_event,
        }
        temp.push(data)
      })

      state.event_workshop_popular = temp
    },
    SET_DETAIL_EVENT(state, data) {
      state.detail_event = data
    },
    SET_EMPTY(state, empty) {
      state.empty = empty
    },
  },

  //actions
  actions: {
    cekPromo({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(`/cek_promo?kode_promo=${param.kode_promo}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    list({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/promo?page=${param.page}&per_page=${param.per_page}&search=${param.search}&status=${param.status}`,
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getDetail({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/promo/promo/detail/${param.kode}?page=${param.page}&per_page=${param.per_page}&search=${param.search}&status=${param.status}`,
        )
          .then((response) => {
            commit('SET_DETAIL_EVENT', response.data.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    add_promo({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/promo`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deactived({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/promo/deactived`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    changeStatus({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/promo/changeStatus`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleted({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/promo/delete/${param.id_promo}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    actived({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/promo/actived`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getEvent({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/promo/eventPromo`)
          .then((response) => {
            commit('SET_EVENT', response.data.data.data)
            commit('SET_EVENT_POPULAR_ADMIN', response.data.data.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    getEvent(state) {
      return state.event
    },
    getDetailEvent(state) {
      return state.detail_event
    },
    getEventPopular(state) {
      return state.event_workshop_popular
    },
  },
}

export default promo
